import {
  AnnouncementFilterKeys,
  AnnouncementListUrlFiltersOpts
} from "@saleor/announcements/components/AnnouncementListPage/filters";
import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, joinDateTime, maybe } from "@saleor/misc";
import {
  AnnouncementInput,
  AnnouncementPublishingStatusEnum
} from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  AnnouncementListUrlFilters,
  AnnouncementListUrlFiltersEnum,
  AnnouncementListUrlQueryParams
} from "../../urls";
export const ANNOUNCEMENT_FILTERS_KEY = "announcementFilters";

export function getFilterOpts(
  params: AnnouncementListUrlFilters
): AnnouncementListUrlFiltersOpts {
  return {
    started: {
      active: maybe(
        () =>
          [params.startedFrom, params.startedTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.startedTo, ""),
        min: maybe(() => params.startedFrom, "")
      }
    },
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(() =>
        findValueInEnum(params.status, AnnouncementPublishingStatusEnum)
      )
    }
  };
}

export function getFilterVariables(
  params: AnnouncementListUrlFilters
): AnnouncementInput {
  const startDate = "00:00";
  const endDate = "23:59";
  return {
    search: params.query,
    startDate: getGteLteVariables({
      gte: joinDateTime(params.startedFrom, startDate),
      lte: joinDateTime(params.startedTo, endDate)
    }),
    status: maybe(() =>
      findValueInEnum(params.status, AnnouncementPublishingStatusEnum)
    )
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<AnnouncementFilterKeys>
): AnnouncementListUrlFilters {
  const { name } = filter;

  switch (name) {
    case AnnouncementFilterKeys.status:
      return getSingleEnumValueQueryParam(
        filter,
        AnnouncementListUrlFiltersEnum.status,
        AnnouncementPublishingStatusEnum
      );
    case AnnouncementFilterKeys.started:
      return getMinMaxQueryParam(
        filter,
        AnnouncementListUrlFiltersEnum.startedFrom,
        AnnouncementListUrlFiltersEnum.startedTo
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<AnnouncementListUrlFilters>(ANNOUNCEMENT_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  AnnouncementListUrlQueryParams,
  AnnouncementListUrlFilters
>(AnnouncementListUrlFiltersEnum);
